import { useContext } from 'react';
import AudienceContext from './AudienceProvider';

export const useAudienceContext = () => {
  const context = useContext(AudienceContext);
  if (context === undefined) {
    throw new Error('Context must be used within a Provider');
  }
  return context;
};
